export default __webpack_public_path__ + "ui/assets/img/arrow-list-up-16.svg";